var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFooter5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.932,
    height: 51.086,
    viewBox: "0 0 31.932 51.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#36c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M892.174,3015.569l1.619-1.079v6.782a1,1,0,1,0,2,0v-23.546a2,2,0,1,1,3.991,0v19.556a1,1,0,0,0,2,0V3010.3a2,2,0,0,1,3.991,0v6.984a1,1,0,0,0,2,0v-4.989a2,2,0,1,1,3.99,0v4.989a1,1,0,0,0,2,0v-2.993a2,2,0,1,1,3.991,0v7.772a22.76,22.76,0,0,1-3.823,12.627.991.991,0,0,0-.168.553v3.593H897.785v-3.593a1,1,0,0,0-.292-.706,27.2,27.2,0,0,1-7.555-13.3A5.362,5.362,0,0,1,892.174,3015.569ZM888,3021.688a29.117,29.117,0,0,0,7.761,13.935l.032.033v4.177a1,1,0,0,0,1,1h17.961a1,1,0,0,0,1-1v-4.292a24.737,24.737,0,0,0,3.992-13.478v-7.772a46.037,46.037,0,0,1-9.979-5.987,3.987,3.987,0,0,1-5.985-2,3.966,3.966,0,0,0-2,.534v-9.115a3.991,3.991,0,0,0-7.982,0v14.365l-2.727,1.818A7.363,7.363,0,0,0,888,3021.688Z",
    transform: "translate(-887.803 -2989.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M890.352,2999.616a1,1,0,0,0,1-1,5.987,5.987,0,0,1,11.973,0,1,1,0,0,0,1.995,0,7.982,7.982,0,1,0-15.964,0A1,1,0,0,0,890.352,2999.616Z",
    transform: "translate(-887.356 -2990.637)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFooter5);
export default __webpack_public_path__ + "static/media/icon-footer5.b931e50cc8d0f9a1f079ee6de6e81630.svg";
export { ForwardRef as ReactComponent };